<script lang="ts">
  import { LoadingIndicatorSmall } from "./mod.ts";
  import { Center } from "../layouts/mod.ts";

  export let onClick: () => void;
  export let disabled: boolean = false;
  export let type:
    | "primary"
    | "secondary"
    | "ghost"
    | "white"
    | "warning"
    | "text-button" = "primary";
  export let customClass: string = "";
  export let outset = true;
  export let full = false;
  export let loading = false;
  export let noborder = false;
  export let nominwidth = false;
</script>

<button
  class:outset
  class:noborder
  class:loading
  class="button {type} {customClass}"
  class:w-full={full}
  on:click={onClick}
  {disabled}
  class:min-w-[150px]={!nominwidth}
>
  {#if loading}
    <Center>
      <span class="relative">
        <span class="absolute left-[calc(50%-12px)] top-[calc(50%-12px)]">
          <LoadingIndicatorSmall visible />
        </span>
      </span>
    </Center>
  {:else}
    <slot />
  {/if}
</button>

<style lang="postcss" scoped>
  .button {
    height: 40px;
    font-family: "Urbanist", sans-serif;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    font-size: 16px;
    border-radius: 5px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    outline: none;
    padding-left: 25px;
    padding-right: 25px;
  }
  .noborder {
    border: none;
  }

  .loading {
    pointer-events: none;
  }
  /* Styling is found in app.css */

  .primary {
    @apply bg-green-45 text-grey-0;
  }
  .primary:hover {
    @apply bg-greenGrey-30 text-white;
  }
  .primary:active {
    @apply bg-green-50 text-red-50;
  }
  .primary:focus {
    @apply bg-greenGrey-30 text-white border-solid border-[1px] border-green-45;
  }
  .primary:disabled {
    @apply bg-grey-5 text-grey-20 border-grey-5 cursor-default;
  }

  /* Secondary */
  .secondary {
    @apply bg-green-72 text-white;

    :global(.dark) & {
      @apply bg-[#5b5b5b] text-[#dadada];
    }
  }
  .secondary:hover {
    @apply bg-green-55 text-white;

    :global(.dark) & {
      @apply bg-[#747474] text-[#dadada];
    }
  }
  .secondary:active {
    @apply bg-green-75 text-white;
  }
  .secondary:focus {
    @apply bg-green-55 text-white border-solid border-[1px] border-green-72;

    :global(.dark) & {
      @apply bg-[#747474] text-[#dadada] border-white;
    }
  }
  .secondary:disabled {
    @apply bg-grey-5 text-grey-20 border-grey-5 cursor-default;

    :global(.dark) & {
      @apply bg-[#383838] text-[#999999];
    }
  }

  /* Ghost */
  .ghost {
    @apply bg-transparent text-greenGrey-60 border-solid border-[1px]
      border-greenGrey-10;
  }
  .ghost:hover {
    @apply bg-transparent text-greenGrey-60 border-solid border-[1px]
      border-greenGrey-40;
  }
  .ghost:active {
    @apply bg-transparent text-greenGrey-60 border-solid border-[1px]
      border-greenGrey-40;
  }
  .ghost:focus {
    @apply bg-transparent text-greenGrey-60 border-solid border-[1px]
      border-green-25;
  }
  .ghost:disabled {
    @apply bg-grey-5 text-grey-20 border-grey-5 cursor-default;
  }

  /* White */
  .white {
    @apply bg-transparent text-white border-solid border-[1px] border-white;
  }
  .white:hover {
    @apply bg-transparent text-grey-20 border-solid border-[1px] border-white;
  }
  .white:active {
    @apply bg-transparent text-white border-solid border-[1px] border-white;
  }
  .white:focus {
    @apply bg-transparent text-white border-solid border-[1px] border-white;
  }
  .white:disabled {
    @apply bg-grey-5 text-grey-20 border-grey-5 cursor-default;
  }

  /* Warning */
  .warning {
    @apply bg-[#ffffff] text-[#ff8980] border-solid border-[1px]
      border-[#dfedec];
  }
  .warning:hover {
    @apply bg-[#f9fcfd] text-[#ff8980] border-solid border-[1px]
      border-[#dfedec];
  }
  .warning:active {
    @apply bg-[#ffffff] text-[#ff8980] border-solid border-[1px]
      border-[#dfedec];
  }
  .warning:focus {
    @apply bg-[#ffffff] text-[#ff8980] border-solid border-[1px]
      border-[#dfedec];
  }
  .warning:disabled {
    @apply bg-grey-5 text-grey-20 border-grey-5 cursor-default;
  }
</style>
